<nav class="ops-toolbar" aria-label="Operaciones rápidas">
  <!-- Órdenes | Mesas | Cocina | Entrega -->
  <a class="btn" *ngIf="!foodtruckOnly" routerLink="/admin/order-list" [class.active]="isActive('/admin/order-list')" aria-label="Órdenes">
    <mat-icon>list_alt</mat-icon>
    <span>Órdenes</span>
  </a>
  <a class="btn" routerLink="/admin/tables-list" [class.active]="isActive('/admin/tables-list')" aria-label="Mesas">
    <mat-icon>table_restaurant</mat-icon>
    <span>Mesas</span>
  </a>
  <a class="btn" *ngIf="!foodtruckOnly" routerLink="/admin/kitchen" [class.active]="isActive('/admin/kitchen')" aria-label="Cocina">
    <mat-icon>restaurant_menu</mat-icon>
    <span>Cocina</span>
    <span class="badge" *ngIf="kitchenCount > 0">{{ kitchenCount }}</span>
  </a>
  <a class="btn" *ngIf="!foodtruckOnly" routerLink="/admin/ready" [class.active]="isActive('/admin/ready')" aria-label="Listos">
    <mat-icon>check_circle</mat-icon>
    <span>Entregar</span>
    <span class="badge" *ngIf="readyCount > 0">{{ readyCount }}</span>
  </a>
</nav>
